export default __webpack_public_path__ + "media/images/avatars/avatar21-42f00c7752aa801b0af2906c8f4c072c.png";